import type { DoraFinancialEntity } from './doraFinancialEntity.ts';
import type { DoraBusinessService } from './doraBusinessService.ts';
import type { DoraICTService } from './doraICTService.ts';
import type { DoraControl } from './doraControl.ts';
import type { DoraFinding } from './doraFinding.ts';
import type { DoraIncident } from './doraIncident.ts';
import { isNumber } from './utils.ts';

export interface DoraRisk {
  id?: number;
  title: string;
  description?: string | null;
  status: string;
  financial_entity_id: number;
  business_service_id?: number | null;
  ict_service_id?: number | null;
  financial_entity?: DoraFinancialEntity;
  business_service?: DoraBusinessService | null;
  ict_service?: DoraICTService | null;
  controls?: DoraControl[];
  findings?: DoraFinding[];
  incidents?: DoraIncident[];
}

export type DoraRiskUpdate = Partial<Omit<DoraRisk,
  'id' |
  'financial_entity' |
  'business_service' |
  'ict_service' |
  'controls' |
  'findings' |
  'incidents'
>> & {
  control_ids?: number[];
};

export const doraRiskToUpdate = ({
  id,
  financial_entity,
  business_service,
  ict_service,
  controls,
  findings,
  incidents,
  ...rest
}: DoraRisk): DoraRiskUpdate => ({
  ...rest,
  control_ids: controls?.map(control => control.id).filter(isNumber),
});
